import React from "react";
import { Link } from "react-router-dom";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center" data-testid="not-found">
      <div className="mx-auto max-w-[1200px] px-6 md:px-10 py-40 grid grid-cols-12 gap-6 items-center">
        <div className="col-span-12 md:col-span-7">
          <div className="mono text-xs uppercase tracking-[0.32em] text-gold mb-4">Error · 404</div>
          <MaskedReveal as="h1" className="serif text-6xl md:text-[9vw] leading-[0.9]" lines={["Objection.", <em className="italic text-gold">Page missing.</em>]} />
          <FadeUp delay={0.3} className="mt-8 text-[hsl(var(--muted-foreground))]">The document you seek is not on the record. Perhaps one of these will help.</FadeUp>
          <FadeUp delay={0.4} className="mt-8 flex flex-wrap gap-4">
            <Link to="/" className="btn-ink">Home <ArrowUpRight className="h-4 w-4" /></Link>
            <Link to="/practice-areas" className="btn-ghost">Practice</Link>
            <Link to="/contact" className="btn-ghost">Contact</Link>
          </FadeUp>
        </div>
        <div className="col-span-12 md:col-span-5 chapter-num text-[26vw] md:text-[16vw] leading-none text-right">404</div>
      </div>
    </div>
  );
}
